"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateUtil = void 0;
const humanize_duration_1 = __importDefault(require("humanize-duration"));
class DateUtil {
    static formatDate(timeStamp) {
        const date = new Date(timeStamp);
        const month = date.toLocaleString("en-US", { month: "long" });
        return `${month} ${date.getDate()}, ${date.getFullYear()}`;
    }
    // 日期格式 "2024-03-28 16:00:00" 转为 "1h ago"
    static calculateTimeAgo(timestamp) {
        const givenTime = new Date(timestamp);
        const currentTime = new Date();
        const timeDifference = currentTime.getTime() - givenTime.getTime();
        const shortEnglishHumanizer = humanize_duration_1.default.humanizer({
            largest: 1,
            round: true,
            spacer: "",
            language: "shortEn",
            languages: {
                shortEn: {
                    y: () => "y",
                    mo: () => "mo",
                    w: () => "w",
                    d: () => "d",
                    h: () => "h",
                    m: () => "m",
                    s: () => "s",
                    ms: () => "ms",
                },
            },
        });
        const readableTimeDifference = shortEnglishHumanizer(timeDifference);
        return `${readableTimeDifference} ago`;
    }
    static formatDateToGMT8(date) {
        // 获取星期几的名称
        const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        const dayOfWeek = daysOfWeek[date.getDay()];
        // 获取月份的名称
        const monthsOfYear = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const month = monthsOfYear[date.getMonth()];
        // 获取各个部分的时间，并格式化数字为两位数
        const day = String(date.getDate()).padStart(2, "0");
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");
        // 获取时区偏移量
        const timezoneOffset = -date.getTimezoneOffset(); // 以分钟为单位
        const timezoneHours = String(Math.floor(timezoneOffset / 60)).padStart(2, "0");
        const timezoneMinutes = String(timezoneOffset % 60).padStart(2, "0");
        const timezoneSign = timezoneOffset >= 0 ? "+" : "-";
        // 构建时区字符串
        const timezoneString = `GMT${timezoneSign}${timezoneHours}${timezoneMinutes} (GMT+8)`;
        // 格式化为字符串
        return `${dayOfWeek} ${month} ${day} ${year} ${hours}:${minutes}:${seconds} ${timezoneString}`;
    }
}
exports.DateUtil = DateUtil;
